import { INCOME_SUBGROUP_CATEGORY } from 'src/Enum/IncomeStructure';

export const defaultExtendedValue = {
  incomeCategory: {
    nameTh: '',
    nameEn: '',
    subGroup: INCOME_SUBGROUP_CATEGORY.PRODUCT_INCOME,
    sequence: 1,
  },
};
